import { FileFormField, IFormBase } from '@/forms/typings';
import { FileFormFieldBuilder } from '@/forms/builders';
import { FormFileFieldResponseDTO } from '@/api/base/DTOs';

export const adaptFormFileFieldResponseToFileFormField = (
  formFileFieldResponse: FormFileFieldResponseDTO,
  parentFieldId?: IFormBase['fieldId'],
): FileFormField => {
  return new FileFormFieldBuilder()
    .fieldId(formFileFieldResponse.fieldID)
    .name(formFileFieldResponse.fieldID)
    .label(formFileFieldResponse.name)
    .readonly(
      formFileFieldResponse.readonly || !formFileFieldResponse.isEditable,
    )
    .notApplicable(formFileFieldResponse.notApplicable)
    .showNotApplicable(formFileFieldResponse.showNotApplicable)
    .size(formFileFieldResponse.itemSize)
    .isRequired(formFileFieldResponse.minFileCount > 0)
    .hasAnyValue(formFileFieldResponse.hasAnyValue)
    .maxFileCount(formFileFieldResponse.maxFileCount)
    .minFileCount(formFileFieldResponse.minFileCount)
    .restriction(formFileFieldResponse.restriction)
    .fileNames(formFileFieldResponse.fileNames)
    .parentFieldId(parentFieldId)
    .build();
};
